export const MULTI_OFFERINGS_MIN_WIDTH = 600;
export const MOBILE_MULTI_OFFERINGS_MIN_WIDTH = 260;
